<template>
 	<b-container v-if="$can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <h3>User Management</h3>
                <hr>
            </b-container>
        </b-row>
        <b-row>
            <b-container fluid>
                <b-tabs content-class="mt-3" class="user-manage-tabs" fill>
                    <b-tab title="Users" active>
                        <b-row>
                            <b-col cols="3">
                                <b-form-group>
                                  <b-input-group size="sm">
                                    <b-form-input
                                      v-model="tables.users.filter"
                                      type="search"
                                      id="filterInput"
                                      placeholder="Type to Search"
                                      debounce="500"
                                    ></b-form-input>
                                    <b-input-group-append>
                                      <b-button :disabled="!tables.users.filter" @click="tables.users.filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="3" class="buttons-create">
                                <b-button variant="outline-primary" size="sm" @click="openModal('create-user', '', 'create')">New User</b-button>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-container fluid>
                                <b-table
                                    :key="tables.users.key"
                                    class="users-table"
                                    responsive bordered
                                    hover no-border-collapse
                                    sticky-header="calc(100vh - 250px)"
                                    head-variant="light"
                                    :items="tables.users.items" :fields="tables.users.fields"
                                    :sort-by="tables.users.sortBy"
                                    :per-page="tables.users.perPage"
                                    :current-page="tables.users.currentPage"
                                    :filter="tables.users.filter"
                                    @filtered="onFilteredUsers"
                                    :busy="tables.users.isBusy"
                                >

                                    <template v-slot:table-busy>
                                        <div class="text-center text-default my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                        </div>
                                    </template>

                                    <template v-slot:cell(roles)="row">
                                        <ul>
                                            <li v-for="role in orderBy(row.item.roles, 'display_name')">{{ role.display_name }}</li>
                                        </ul>
                                    </template>

                                    <template v-slot:cell(created_at)="row">
                                        <span>{{ row.item.created_at | moment('MM-DD-YYYY')}}</span>
                                    </template>

                                    <template v-slot:cell(updated_at)="row">
                                        <span>{{ row.item.updated_at | moment('MM-DD-YYYY')}}</span>
                                    </template>

                                    <template v-slot:cell(actions)="row">
                                        <b-container v-if="row.item.name != 'Admin'" class="actions-icons" fluid>
                                            <b-row>
                                                <b-col>
                                                    <b-link @click="openModal('edit-user', row.item, 'edit')"><i class="fas fa-edit"></i></b-link>
                                                </b-col>
                                                <b-col>
                                                    <b-link @click="deleteConfirm('User', row.item.name, row.item)" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                                </b-col>
                                            </b-row>
                                        </b-container>
                                    </template>
                                </b-table>
                            </b-container>
                        </b-row>

                        <b-row>
                            <b-col cols="6">
                                {{ pageTotalsUsers }}
                            </b-col>

                            <b-col cols="6" class="my-1">
                                <b-pagination
                                  v-model="tables.users.currentPage"
                                  :total-rows="tables.users.totalRows"
                                  :per-page="tables.users.perPage"
                                  align="fill"
                                  size="sm"
                                  class="my-0"
                                ></b-pagination>
                            </b-col>
                        </b-row>

                        <b-modal id="modal-company-user-management-create-user" hide-footer>
                            <template v-slot:modal-title>
                                New User: {{ modals['create-user'].create.name }}
                            </template>

                            <b-form @submit.stop.prevent="createUser">
                                <b-form-group
                                    id="input-group-name"
                                    label="Name:"
                                    label-for="input-name"
                                >
                                    <b-form-input
                                        id="input-name"
                                        v-model="modals['create-user'].create.name"
                                        type="text"
                                        required
                                        placeholder="Enter name"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-email"
                                    label="E-mail:"
                                    label-for="input-email"
                                >
                                    <b-form-input
                                        id="input-email"
                                        v-model="modals['create-user'].create.email"
                                        type="text"
                                        required
                                        placeholder="Enter e-mail"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-role"
                                    label="Role:"
                                    label-for="input-role"
                                >
                                    <treeselect
                                        name="treeSelect"
                                        class="treeSelect"
                                        multiple
                                        clearable
                                        searchable
                                        open-on-click
                                        clear-on-select
                                        close-on-select
                                        disableBranchNodes
                                        placeholder=""
                                        :options="tables.users.roles"
                                        v-model="modals['create-user'].rolesSelected"
                                        />
                                </b-form-group>

                                <b-form-group
                                    id="input-group-password"
                                    label="Password:"
                                    label-for="input-password"
                                >
                                    <b-form-input
                                        id="input-password"
                                        v-model="modals['create-user'].create.password"
                                        type="text"
                                        placeholder="Enter password"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-button type="submit" variant="primary">
                                    <span v-if="modals['create-user'].submitting">
                                        <b-spinner small type="grow"></b-spinner>
                                        Updating...
                                    </span>
                                    <span v-else>Create</span>
                                </b-button>
                            </b-form>
                        </b-modal>

                        <b-modal id="modal-company-user-management-edit-user" hide-footer>
                            <template v-slot:modal-title>
                                Editing: {{ modals['edit-user'].edit.name }}
                            </template>

                            <b-form @submit.stop.prevent="updateUser">
                                <b-form-group
                                    id="input-group-name"
                                    label="Name:"
                                    label-for="input-name"
                                >
                                    <b-form-input
                                        id="input-name"
                                        v-model="modals['edit-user'].edit.name"
                                        type="text"
                                        required
                                        placeholder="Enter name"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-email"
                                    label="E-mail:"
                                    label-for="input-email"
                                >
                                    <b-form-input
                                        id="input-email"
                                        v-model="modals['edit-user'].edit.email"
                                        type="text"
                                        required
                                        placeholder="Enter e-mail"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-role"
                                    label="Role:"
                                    label-for="input-role"
                                >
                                    <treeselect
                                        name="treeSelect"
                                        class="treeSelect"
                                        multiple
                                        clearable
                                        searchable
                                        open-on-click
                                        clear-on-select
                                        close-on-select
                                        disableBranchNodes
                                        placeholder=""
                                        :options="tables.users.roles"
                                        v-model="modals['edit-user'].rolesSelected"
                                        />
                                </b-form-group>

                                <b-form-group
                                    id="input-group-password"
                                    label="New Password:"
                                    label-for="input-password"
                                >
                                    <b-form-input
                                        id="input-password"
                                        v-model="modals['edit-user'].edit.password"
                                        type="text"
                                        placeholder="Enter password"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-button type="submit" variant="primary">
                                    <span v-if="modals['edit-user'].submitting">
                                        <b-spinner small type="grow"></b-spinner>
                                        Updating...
                                    </span>
                                    <span v-else>Update</span>
                                </b-button>
                            </b-form>
                        </b-modal>
                    </b-tab>
                    <b-tab title="Roles">
                        <b-row>
                            <b-col cols="3">
                                <b-form-group>
                                  <b-input-group size="sm">
                                    <b-form-input
                                      v-model="tables.roles.filter"
                                      type="search"
                                      id="filterInput"
                                      placeholder="Type to Search"
                                      debounce="500"
                                    ></b-form-input>
                                    <b-input-group-append>
                                      <b-button :disabled="!tables.roles.filter" @click="tables.roles.filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="3" class="buttons-create">
                                <b-button variant="outline-primary" size="sm" @click="openModal('create-role', '', 'create')">New Role</b-button>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-container fluid>
                                <b-table
                                    :key="tables.roles.key"
                                    class="roles-table"
                                    responsive bordered
                                    hover no-border-collapse
                                    sticky-header="calc(100vh - 250px)"
                                    head-variant="light"
                                    :items="tables.roles.items" :fields="tables.roles.fields"
                                    :sort-by="tables.roles.sortBy"
                                    :sort-desc="tables.roles.sortDesc"
                                    :per-page="tables.roles.perPage"
                                    :current-page="tables.roles.currentPage"
                                    :filter="tables.roles.filter"
                                    @filtered="onFilteredRoles"
                                    :busy="tables.roles.isBusy"
                                >

                                    <template v-slot:table-busy>
                                        <div class="text-center text-default my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                        </div>
                                    </template>

                                    <template v-slot:cell(permissions)="row">
                                        <ul>
                                            <li v-for="permission in orderBy(row.item.permissions, 'display_name')">{{ permission.display_name }}</li>
                                        </ul>
                                    </template>

                                    <template v-slot:cell(created_at)="row">
                                        <span>{{ row.item.created_at | moment("MM-DD-YYYY")}}</span>
                                    </template>

                                    <template v-slot:cell(updated_at)="row">
                                        <span>{{ row.item.updated_at | moment("MM-DD-YYYY")}}</span>
                                    </template>

                                    <template v-slot:cell(actions)="row">
                                        <b-container v-if="row.item.name != 'admin'" class="actions-icons" fluid>
                                            <b-row>
                                                <b-col>
                                                    <b-link @click="openModal('edit-role', row.item, 'edit')"><i class="fas fa-edit"></i></b-link>
                                                </b-col>
                                                <b-col>
                                                    <b-link @click="deleteConfirm('Role', row.item.name, row.item)" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                                </b-col>
                                            </b-row>
                                        </b-container>
                                    </template>
                                </b-table>
                            </b-container>
                        </b-row>

                        <b-row>
                            <b-col cols="6">
                                {{ pageTotalsRoles }}
                            </b-col>

                            <b-col cols="6" class="my-1">
                                <b-pagination
                                  v-model="tables.roles.currentPage"
                                  :total-rows="tables.roles.totalRows"
                                  :per-page="tables.roles.perPage"
                                  align="fill"
                                  size="sm"
                                  class="my-0"
                                ></b-pagination>
                            </b-col>
                        </b-row>

                        <b-modal id="modal-company-user-management-create-role" hide-footer>
                            <template v-slot:modal-title>
                                New Role: {{ modals['create-role'].create.name }}
                            </template>

                            <b-form @submit.stop.prevent="createRole">
                                <b-form-group
                                    id="input-group-name"
                                    label="Name:"
                                    label-for="input-name"
                                >
                                    <b-form-input
                                        id="input-name"
                                        v-model="modals['create-role'].create.name"
                                        type="text"
                                        required
                                        placeholder="Enter name"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-display-name"
                                    label="Display Name:"
                                    label-for="input-display-name"
                                >
                                    <b-form-input
                                        id="input-display-name"
                                        v-model="modals['create-role'].create.display_name"
                                        type="text"
                                        required
                                        placeholder="Enter display name"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-description"
                                    label="Description:"
                                    label-for="input-description"
                                >
                                    <b-form-input
                                        id="input-description"
                                        v-model="modals['create-role'].create.description"
                                        type="text"
                                        placeholder="Enter description"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-permissions"
                                    label="Permissions:"
                                    label-for="input-permissions"
                                >
                                    <treeselect
                                        name="treeSelect"
                                        class="treeSelect"
                                        multiple
                                        clearable
                                        searchable
                                        open-on-click
                                        clear-on-select
                                        close-on-select
                                        disableBranchNodes
                                        placeholder=""
                                        :options="tables.roles.permissions"
                                        v-model="modals['create-role'].permissionsSelected"
                                        />
                                </b-form-group>

                                <b-button type="submit" variant="primary">
                                    <span v-if="modals['create-role'].submitting">
                                        <b-spinner small type="grow"></b-spinner>
                                        Updating...
                                    </span>
                                    <span v-else>Create</span>
                                </b-button>
                            </b-form>
                        </b-modal>

                        <b-modal id="modal-company-user-management-edit-role" hide-footer>
                            <template v-slot:modal-title>
                                Editing: {{ modals['edit-role'].edit.name }}
                            </template>

                            <b-form @submit.stop.prevent="updateRole">
                                <b-form-group
                                    id="input-group-name"
                                    label="Name:"
                                    label-for="input-name"
                                >
                                    <b-form-input
                                        id="input-name"
                                        v-model="modals['edit-role'].edit.name"
                                        type="text"
                                        required
                                        placeholder="Enter name"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-display-name"
                                    label="Display Name:"
                                    label-for="input-display-name"
                                >
                                    <b-form-input
                                        id="input-display-name"
                                        v-model="modals['edit-role'].edit.display_name"
                                        type="text"
                                        required
                                        placeholder="Enter display name"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-description"
                                    label="Description:"
                                    label-for="input-description"
                                >
                                    <b-form-input
                                        id="input-description"
                                        v-model="modals['edit-role'].edit.description"
                                        type="text"
                                        placeholder="Enter description"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-permissions"
                                    label="Permissions:"
                                    label-for="input-permissions"
                                >
                                    <treeselect
                                        name="treeSelect"
                                        class="treeSelect"
                                        multiple
                                        clearable
                                        searchable
                                        open-on-click
                                        clear-on-select
                                        close-on-select
                                        disableBranchNodes
                                        placeholder=""
                                        :options="tables.roles.permissions"
                                        v-model="modals['edit-role'].permissionsSelected"
                                        />
                                </b-form-group>

                                <b-button type="submit" variant="primary">
                                    <span v-if="modals['edit-role'].submitting">
                                        <b-spinner small type="grow"></b-spinner>
                                        Updating...
                                    </span>
                                    <span v-else>Update</span>
                                </b-button>
                            </b-form>
                        </b-modal>
                    </b-tab>
                    <b-tab title="Permissions">
                        <b-row>
                            <b-col cols="3">
                                <b-form-group>
                                  <b-input-group size="sm">
                                    <b-form-input
                                      v-model="tables.permissions.filter"
                                      type="search"
                                      id="filterInput"
                                      placeholder="Type to Search"
                                      debounce="500"
                                    ></b-form-input>
                                    <b-input-group-append>
                                      <b-button :disabled="!tables.permissions.filter" @click="tables.permissions.filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="3" class="buttons-create">
                                <b-button variant="outline-primary" size="sm" @click="openModal('create-permission', '', 'create')">New Permission</b-button>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-container fluid>
                                <b-table
                                    :key="tables.permissions.key"
                                    class="permissions-table"
                                    responsive bordered
                                    hover no-border-collapse
                                    sticky-header="calc(100vh - 250px)"
                                    head-variant="light"
                                    :items="tables.permissions.items" :fields="tables.permissions.fields"
                                    :sort-by="tables.permissions.sortBy"
                                    :sort-desc="tables.permissions.sortDesc"
                                    :per-page="tables.permissions.perPage"
                                    :current-page="tables.permissions.currentPage"
                                    :filter="tables.permissions.filter"
                                    @filtered="onFilteredPermissions"
                                    :busy="tables.permissions.isBusy"
                                >

                                    <template v-slot:table-busy>
                                        <div class="text-center text-default my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                        </div>
                                    </template>

                                    <template v-slot:cell(created_at)="row">
                                        <span>{{ row.item.created_at | moment("MM-DD-YYYY")}}</span>
                                    </template>

                                    <template v-slot:cell(updated_at)="row">
                                        <span>{{ row.item.updated_at | moment("MM-DD-YYYY")}}</span>
                                    </template>

                                    <template v-slot:cell(actions)="row">
                                        <b-container v-if="row.item.name != 'view-all'" class="actions-icons" fluid>
                                            <b-row>
                                                <b-col>
                                                    <b-link @click="openModal('edit-permission', row.item, 'edit')"><i class="fas fa-edit"></i></b-link>
                                                </b-col>
                                                <b-col>
                                                    <b-link @click="deleteConfirm('Permission', row.item.name, row.item)" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                                </b-col>
                                            </b-row>
                                        </b-container>
                                    </template>
                                </b-table>
                            </b-container>
                        </b-row>

                        <b-row>
                            <b-col cols="6">
                                {{ pageTotalsPermissions }}
                            </b-col>

                            <b-col cols="6" class="my-1">
                                <b-pagination
                                  v-model="tables.permissions.currentPage"
                                  :total-rows="tables.permissions.totalRows"
                                  :per-page="tables.permissions.perPage"
                                  align="fill"
                                  size="sm"
                                  class="my-0"
                                ></b-pagination>
                            </b-col>
                        </b-row>

                        <b-modal id="modal-company-user-management-create-permission" hide-footer>
                            <template v-slot:modal-title>
                                New Permission: {{ modals['create-permission'].create.name }}
                            </template>

                            <b-form @submit.stop.prevent="createPermission">
                                <b-form-group
                                    id="input-group-name"
                                    label="Name:"
                                    label-for="input-name"
                                >
                                    <b-form-input
                                        id="input-name"
                                        v-model="modals['create-permission'].create.name"
                                        type="text"
                                        required
                                        placeholder="Enter name"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-display-name"
                                    label="Display Name:"
                                    label-for="input-display-name"
                                >
                                    <b-form-input
                                        id="input-display-name"
                                        v-model="modals['create-permission'].create.display_name"
                                        type="text"
                                        required
                                        placeholder="Enter display name"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-description"
                                    label="Description:"
                                    label-for="input-description"
                                >
                                    <b-form-input
                                        id="input-description"
                                        v-model="modals['create-permission'].create.description"
                                        type="text"
                                        placeholder="Enter description"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-button type="submit" variant="primary">
                                    <span v-if="modals['create-permission'].submitting">
                                        <b-spinner small type="grow"></b-spinner>
                                        Updating...
                                    </span>
                                    <span v-else>Create</span>
                                </b-button>
                            </b-form>
                        </b-modal>

                        <b-modal id="modal-company-user-management-edit-permission" hide-footer>
                            <template v-slot:modal-title>
                                Editing: {{ modals['edit-permission'].edit.name }}
                            </template>

                            <b-form @submit.stop.prevent="updatePermission">
                                <b-form-group
                                    id="input-group-name"
                                    label="Name:"
                                    label-for="input-name"
                                >
                                    <b-form-input
                                        id="input-name"
                                        v-model="modals['edit-permission'].edit.name"
                                        type="text"
                                        required
                                        placeholder="Enter name"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-display-name"
                                    label="Display Name:"
                                    label-for="input-display-name"
                                >
                                    <b-form-input
                                        id="input-display-name"
                                        v-model="modals['edit-permission'].edit.display_name"
                                        type="text"
                                        required
                                        placeholder="Enter display name"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-description"
                                    label="Description:"
                                    label-for="input-description"
                                >
                                    <b-form-input
                                        id="input-description"
                                        v-model="modals['edit-permission'].edit.description"
                                        type="text"
                                        placeholder="Enter description"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-button type="submit" variant="primary">
                                    <span v-if="modals['edit-permission'].submitting">
                                        <b-spinner small type="grow"></b-spinner>
                                        Updating...
                                    </span>
                                    <span v-else>Update</span>
                                </b-button>
                            </b-form>
                        </b-modal>
                    </b-tab>
                </b-tabs>
            </b-container>
        </b-row>
    </b-container>
 	</div>
</template>

<script>
    import Vue2Filters from 'vue2-filters'
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
 	export default {
    	name: 'UserManage',

        metaInfo() {
            return {
                title: 'User Management',
            }
        },

    	components: {
      		Treeselect
    	},
        mixins: [Vue2Filters.mixin],
        data() {
            return {
                modals: {
                    'create-user': {
                        create: {},
                        key: 1,
                        submitting: 0,
                        rolesSelected: []
                    },

                    'edit-user': {
                        edit: [],
                        key: 1,
                        submitting: 0,
                        rolesSelected: []
                    },

                    'create-role': {
                        create: {},
                        key: 1,
                        submitting: 0,
                        permissionsSelected: []
                    },

                    'edit-role': {
                        edit: [],
                        key: 1,
                        submitting: 0,
                        permissionsSelected: []
                    },

                    'create-permission': {
                        create: {},
                        key: 1,
                        submitting: 0
                    },

                    'edit-permission': {
                        edit: [],
                        key: 1,
                        submitting: 0
                    },
                },
                tables: {
                    users: {
                        isBusy: false,
                        totalRows: 1,
                        currentPage: 1,
                        perPage: 50,
                        pageOptions: [20, 50, 100, 500, 1000],
                        sortBy: 'name',
                        sortDesc: true,
                        // sortDirection: 'asc',
                        filter: null,
                        filterCat: '',
                        key: 1,
                        fields: [
                            {
                                key: 'name',
                                label: 'Name',
                                sortable: true
                            },
                            {
                                key: 'email',
                                label: 'E-mail',
                                sortable: true
                            },
                            {
                                key: 'roles',
                                label: 'Roles'
                            },
                            {
                                key: 'created_at',
                                label: 'Date Created',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' }
                            },
                            {
                                key: 'updated_at',
                                label: 'Date Updated',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' }
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'user-management-table-style-actions'
                            }
                        ],

                        items: [],
                        roles: []
                    },
                    roles: {
                        isBusy: false,
                        totalRows: 1,
                        currentPage: 1,
                        perPage: 50,
                        pageOptions: [20, 50, 100, 500, 1000],
                        sortBy: 'name',
                        sortDesc: false,
                        // sortDirection: 'asc',
                        filter: null,
                        filterCat: '',
                        key: 1,
                        fields: [
                            {
                                key: 'name',
                                label: 'Name',
                                sortable: true
                            },
                            {
                                key: 'display_name',
                                label: 'Display Name',
                                sortable: true
                            },
                            {
                                key: 'description',
                                label: 'Description',
                                sortable: true
                            },
                            {
                                key: 'permissions',
                                label: 'Permissions',
                            },
                            {
                                key: 'created_at',
                                label: 'Date Created',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' }
                            },
                            {
                                key: 'updated_at',
                                label: 'Date Updated',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' }
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'user-management-table-style-actions'
                            }
                        ],

                        items: [],
                        permissions: []
                    },
                    permissions: {
                        isBusy: false,
                        totalRows: 1,
                        currentPage: 1,
                        perPage: 50,
                        pageOptions: [20, 50, 100, 500, 1000],
                        sortBy: 'description',
                        sortDesc: false,
                        // sortDirection: 'asc',
                        filter: null,
                        filterCat: '',
                        key: 1,
                        fields: [
                            {
                                key: 'name',
                                label: 'Name',
                                sortable: true
                            },
                            {
                                key: 'display_name',
                                label: 'Display Name',
                                sortable: true
                            },
                            {
                                key: 'description',
                                label: 'Description',
                                sortable: true
                            },
                            {
                                key: 'created_at',
                                label: 'Date Created',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' }
                            },
                            {
                                key: 'updated_at',
                                label: 'Date Updated',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' }
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'user-management-table-style-actions'
                            }
                        ],

                        items: []
                    },
                },
            }
        },
        methods: {
            openModal(modalName, row) {
                let prefix = 'modal-company-user-management-'
                switch (modalName) {
                    case 'edit-user':
                        this.modals[modalName].edit = Object.assign({}, row)
                        this.setCurrentUserRoles(row.roles)

                        break;
                    case 'edit-role':
                        this.modals[modalName].edit = Object.assign({}, row)
                        this.setCurrentRolePermissions(row.permissions)

                        break;
                    case 'edit-permission':
                        this.modals[modalName].edit = Object.assign({}, row)

                        break;
                }

                this.$bvModal.show(prefix + modalName)
            },

            closeModal(modalName) {
                this.$bvModal.hide(modalName)
            },

            toggleBusy(table) {
                this.tables[table].isBusy = !this.tables[table].isBusy
            },

            updateUser() {
                this.modals['edit-user'].submitting = 1
                let url = 'api/company/user-management/updateuser'
                let row = this.modals['edit-user'].edit
                let roles = this.modals['edit-user'].rolesSelected
                axios.post(url, {
                    row,
                    roles
                })
                .then((res) => {
                    let index = this.findIndex(this.tables.users.items, 'id', row.id)
                    this.tables.users.items[index] = res.data.updatedRow
                    this.closeModal('modal-company-user-management-edit-user')
                    this.modals['edit-user'].submitting = 0
                    this.tables.users.key++
                    this.showAlertBox('success', 'Edit User', 'User ' + row.name + ' has been updated!')
                }, () => {
                    this.has_error = true
                })
            },

            updateRole() {
                this.modals['edit-role'].submitting = 1
                let url = 'api/company/user-management/updaterole'
                let row = this.modals['edit-role'].edit
                let permissions = this.modals['edit-role'].permissionsSelected

                axios.post(url, {
                    row,
                    permissions
                })
                .then((res) => {
                    this.closeModal('modal-company-user-management-edit-role')
                    this.modals['edit-role'].submitting = 0
                    this.tables.roles.key++
                    this.showAlertBox('success', 'Edit Role', 'Role ' + row.name + ' has been updated!')
                    this.getRoles(null, true)
                    this.getUsers(null, true)
                }, () => {
                    this.has_error = true
                })
            },

            updatePermission() {
                this.modals['edit-permission'].submitting = 1
                let url = 'api/company/user-management/updatepermission'
                let row = this.modals['edit-permission'].edit

                axios.post(url, {
                    row
                })
                .then((res) => {
                    this.closeModal('modal-company-user-management-edit-permission')
                    this.modals['edit-permission'].submitting = 0
                    this.tables.permissions.key++
                    this.showAlertBox('success', 'Edit Permission', 'Permission ' + row.name + ' has been updated!')
                    this.getPermissions(null, true)
                    this.getRoles(null, true)
                }, () => {
                    this.has_error = true
                })
            },

            createUser() {
                this.modals['create-user'].submitting = 1
                let url = 'api/company/user-management/createuser'
                let row = this.modals['create-user'].create
                let roles = this.modals['create-user'].rolesSelected
                axios.post(url, {
                    row,
                    roles
                })
                .then((res) => {
                    this.tables.users.items.push(res.data.createdRow)
                    this.closeModal('modal-company-user-management-create-user')
                    this.modals['create-user'].submitting = 0
                    this.tables.users.key++
                    this.showAlertBox('success', 'Create User', 'User ' + row.name + ' has been created!')
                }, () => {
                    this.has_error = true
                })
            },

            createRole() {
                this.modals['create-role'].submitting = 1
                let url = 'api/company/user-management/createrole'
                let row = this.modals['create-role'].create
                let permissions = this.modals['create-role'].permissionsSelected
                axios.post(url, {
                    row,
                    permissions
                })
                .then((res) => {
                    // this.tables.roles.items.push(res.data.createdRow)
                    this.closeModal('modal-company-user-management-create-role')
                    this.modals['create-role'].submitting = 0
                    // this.tables.roles.key++
                    this.showAlertBox('success', 'Create Role', 'Role ' + row.name + ' has been created!')
                    this.getRoles(null, true)
                }, () => {
                    this.has_error = true
                })
            },

            createPermission() {
                this.modals['create-permission'].submitting = 1
                let url = 'api/company/user-management/createpermission'
                let row = this.modals['create-permission'].create

                axios.post(url, {
                    row
                })
                .then((res) => {
                    // this.tables.roles.items.push(res.data.createdRow)
                    this.closeModal('modal-company-user-management-create-permission')
                    this.modals['create-permission'].submitting = 0
                    // this.tables.permissions.key++
                    this.showAlertBox('success', 'Create Permission', 'Permission ' + row.name + ' has been created!')
                    this.getPermissions(null, true)
                    this.getRoles(null, true)
                }, () => {
                    this.has_error = true
                })
            },

            deleteConfirm(area, name, row) {
                // let boxConfirmModal = this.modals['modal-delete'].box

                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete: ' + name, {
                        title: 'Delete: ' + name,
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Confirm',
                        cancelTitle: 'Cancel',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                })
                .then(value => {
                    if (value) {
                        this['delete' + area](row)
                    }
                })
                .catch(err => {
                    // An error occurred
                })
            },

            deleteUser(row) {
                let url = 'api/company/user-management/deleteuser'

                axios.post(url, {
                    id: row.id
                })
                .then((res) => {
                    let index = this.findIndex(this.tables.users.items, 'id', row.id)
                    this.tables.users.items.splice(index, 1)
                    this.tables.users.key++
                    this.showAlertBox('success', 'Delete User', 'User ' + row.name + ' has been deleted!')
                }, () => {
                    this.has_error = true
                })
            },

            deleteRole(row) {
                let url = 'api/company/user-management/deleterole'

                axios.post(url, {
                    id: row.id
                })
                .then((res) => {
                    // let index = this.findIndex(this.tables.roles.items, 'id', row.id)
                    // this.tables.roles.items.splice(index, 1)
                    // this.tables.roles.key++
                    this.showAlertBox('success', 'Delete Role', 'Role ' + row.name + ' has been deleted!')
                    this.getRoles(null, true)
                    this.getUsers(null, true)
                }, () => {
                    this.has_error = true
                })
            },

            deletePermission(row) {
                let url = 'api/company/user-management/deletepermission'

                axios.post(url, {
                    id: row.id
                })
                .then((res) => {
                    // let index = this.findIndex(this.tables.roles.items, 'id', row.id)
                    // this.tables.roles.items.splice(index, 1)
                    // this.tables.roles.key++
                    this.showAlertBox('success', 'Delete Permission', 'Permission ' + row.name + ' has been deleted!')
                    this.getPermissions(null, true)
                    this.getRoles(null, true)
                }, () => {
                    this.has_error = true
                })
            },

            getUsers(id, silent) {
                if (!silent) {
                    this.toggleBusy('users')
                }

                let url = 'api/company/user-management/getusers'
                axios.post(url, {
                    id: id
                })
                .then((res) => {
                    if (res.data.users.length) {
                        this.tables.users.items = res.data.users
                        this.tables.users.totalRows = this.tables.users.items.length
                    }

                    if (!silent) {
                        this.toggleBusy('users')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            setCurrentUserRoles(roles) {
                this.modals['edit-user'].rolesSelected = []

                roles.forEach(element => {
                    this.modals['edit-user'].rolesSelected.push(element.id)
                })

                this.modals['edit-user'].rolesSelected.sort()
            },

            setCurrentRolePermissions(roles) {
                this.modals['edit-role'].permissionsSelected = []

                roles.forEach(element => {
                    this.modals['edit-role'].permissionsSelected.push(element.id)
                })

                this.modals['edit-role'].permissionsSelected.sort()
            },

            getRoles(id, silent) {
                if (!silent) {
                    this.toggleBusy('roles')
                }

                let url = 'api/company/user-management/getroles'
                axios.post(url, {
                    id: id
                })
                .then((res) => {
                    if (res.data.roles.length) {
                        this.tables.roles.items = res.data.roles
                        this.tables.roles.totalRows = this.tables.roles.items.length

                        this.tables.users.roles = []
                        let rolesArr = this.tables.users.roles
                        res.data.roles.forEach(element => {
                            let index = this.findIndex(this.tables.users.roles, 'id', element.id)
                            if (index == -1) {
                                let arr = {id: element.id, label: element.display_name}
                                rolesArr.push(arr)
                            }
                        })

                        rolesArr.sort((a, b) => (a.label > b.label) ? 1 : -1)
                    }

                    if (!silent) {
                        this.toggleBusy('roles')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            getPermissions(id, silent) {
                if (!silent) {
                    this.toggleBusy('permissions')
                }

                let url = 'api/company/user-management/getpermissions'
                axios.post(url, {
                    id: id
                })
                .then((res) => {
                    if (res.data.permissions.length) {
                        this.tables.permissions.items = res.data.permissions
                        this.tables.permissions.totalRows = this.tables.permissions.items.length

                        this.tables.roles.permissions = []
                        let permissionsArr = this.tables.roles.permissions
                        res.data.permissions.forEach(element => {
                            let arr = {id: element.id, label: element.display_name}
                            permissionsArr.push(arr)
                        })

                        permissionsArr.sort((a, b) => (a.label > b.label) ? 1 : -1)
                    }

                    if (!silent) {
                        this.toggleBusy('permissions')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            onFilteredUsers(filteredItems) {
                this.tables.users.totalRows = filteredItems.length
                this.tables.users.currentPage = 1
            },

            onFilteredRoles(filteredItems) {
                this.tables.roles.totalRows = filteredItems.length
                this.tables.roles.currentPage = 1
            },

            onFilteredPermissions(filteredItems) {
                this.tables.permissions.totalRows = filteredItems.length
                this.tables.permissions.currentPage = 1
            }
        },
    	computed: {
	    	sortOptions() {
                // Create an options list from our fields
                return this.tables.transactions.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return { text: f.label, value: f.key }
                    })
            },

            pageTotalsUsers() {
                let totalRows = this.tables.users.totalRows
                let currentPage = this.tables.users.currentPage
                let perPage = this.tables.users.perPage

                let from
                let to

                if (perPage > totalRows) {
                    from = 1
                    to = totalRows
                } else {
                    to = perPage * currentPage
                    from = to - perPage + 1
                }

                return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.users.totalRows + ' rows'
            },

            pageTotalsRoles() {
                let totalRows = this.tables.roles.totalRows
                let currentPage = this.tables.roles.currentPage
                let perPage = this.tables.roles.perPage

                let from
                let to

                if (perPage > totalRows) {
                    from = 1
                    to = totalRows
                } else {
                    to = perPage * currentPage
                    from = to - perPage + 1
                }

                return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.roles.totalRows + ' rows'
            },

            pageTotalsPermissions() {
                let totalRows = this.tables.permissions.totalRows
                let currentPage = this.tables.permissions.currentPage
                let perPage = this.tables.permissions.perPage

                let from
                let to

                if (perPage > totalRows) {
                    from = 1
                    to = totalRows
                } else {
                    to = perPage * currentPage
                    from = to - perPage + 1
                }

                return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.permissions.totalRows + ' rows'
            }
	    },
	    mounted() {
            this.getUsers()
            this.getRoles()
            this.getPermissions()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-company-user-management-edit-user':
                        this.modals['edit-user'].edit = []
                        this.modals['edit-user'].rolesSelected = []

                        break
                    case 'modal-company-user-management-create-user':
                        this.modals['create-user'].create = {}
                        this.modals['create-user'].rolesSelected = []

                        break;
                    case 'modal-company-user-management-create-role':
                        this.modals['create-role'].create = {}
                        this.modals['create-role'].permissionsSelected = []

                        break;
                    case 'modal-company-user-management-edit-role':
                        this.modals['edit-role'].edit = []
                        this.modals['edit-role'].permissionsSelected = []

                        break;
                    case 'modal-company-user-management-create-permission':
                        this.modals['create-permission'].create = {}

                        break;
                    case 'modal-company-user-management-edit-permission':
                        this.modals['edit-permission'].edit = []

                        break;
                }
            })

            // pusher
            // Echo.channel('table-transaction-ledger-updated')
            //     .listen('TableTransactionLedgerUpdated', (e) => {
            //     this.getTransactions(null, 1)
            // })
	    }
  }
</script>
<style lang="scss">
    .users-table, .roles-table, .permissions-table {
        height: 75vh;
    }

    .user-manage-tabs {
        .nav-item {
            a {
                color: #000;
                font-weight: bold;
            }

            a.active {
                background: #007bff;
                color: #fff;
            }
        }
    }

    .buttons-create {
        margin-bottom: 10px;
    }

    .treeSelect {
        .vue-treeselect__control {
            height: calc(1.5em + 0.5rem + 2px);
            padding-top: 0.25rem;
            padding-bottom: 0.25rem;
            padding-left: 0.5rem;
            font-size: 0.7875rem;

            .vue-treeselect__placeholder, .vue-treeselect__single-value {
                line-height: 1.5
            }
        }
    }

    .user-management-table-style-actions {
        width: 120px;

        .actions-icons {
            text-align: center;
        }
    }
</style>
